<template>
  <div>
    <GoodsTable :orderCode="orderCode" />
  </div>
</template>
<script>
import GoodsTable from './components/table'
export default {
  components: { GoodsTable },
  props: { orderCode: { type: String, default: '' } },
}
</script>
